import { render, staticRenderFns } from "./CustomHeaderRows.vue?vue&type=template&id=2633885d&scoped=true&"
import script from "./CustomHeaderRows.vue?vue&type=script&lang=js&"
export * from "./CustomHeaderRows.vue?vue&type=script&lang=js&"
import style0 from "./CustomHeaderRows.vue?vue&type=style&index=0&id=2633885d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633885d",
  null
  
)

export default component.exports